import { styleConstants } from '@paywithextend/components'
import React from 'react'
import Tooltip from 'src/components/Tooltip/Tooltip'
import Trns from 'src/localization/Trns'
import { css } from 'styled-components'

interface EmployeeIdTooltipProps {
  className?: string
  openLeft: boolean
}

const EmployeeIdTooltip: React.FC<EmployeeIdTooltipProps> = (
  props,
): React.ReactElement => {
  return (
    <Tooltip className={props.className} openLeft={props.openLeft}>
      <p>
        <Trns
          source={
            '${employeeId} is an ID code provided by your employer and will help your finance team identify the purchases you make.'
          }
          expressions={{
            employeeId: (
              <span
                css={css`
                  font-family: ${styleConstants.fontFamilies.medium};
                `}
              >
                <Trns source={'Employee ID'} />
              </span>
            ),
          }}
        />
      </p>
    </Tooltip>
  )
}

export default EmployeeIdTooltip
